import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CanActivate } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

@Injectable()
export class ValidarMarca implements CanActivate {

    paramLogin: string;

    constructor(
        private msalService: MsalUserService, 
        private router: Router,    
        private activeRoute: ActivatedRoute) { }

    canActivate() {
        if (environment.tipoUsuario=='Marca' || environment.tipoUsuario == 'ReporteMarca,Marca' || environment.tipoUsuario=='Pactia' || environment.tipoUsuario=='Marca,MarcaCertificada' || 
            environment.tipoUsuario=='ReporteMarca,Marca,MarcaCertificada' ||
            environment.tipoUsuario=='ReporteMarca,MarcaCertificada'||
            environment.tipoUsuario=='Administrador'
         || environment.tipoUsuario=='Pactia' ) {
           
            return true;
        }
        else
        {
            Swal.fire({
                icon: 'error',
                title: 'Acceso Denegado...',
                text: 'Solo ingresan Marcas para registro de ventas diarias.'
              })
            return false;
        }
    }
}